import React from "react";
import { Link } from "react-router-dom";
import {
    Card,
    CardContent,
    Box,
    CardHeader,
    Typography,
    Stack,
    Button,
} from "@mui/material";

import RMSAvatar from "../RMSAvatar";
import AppraisalTable from "../Appraisal/AppraisalTable";

import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";

function AppraiseeCard({ appraisee }) {
    const uuid = appraisee?.uuid?.length > 0 ? appraisee.uuid : null;
    const appraisals = appraisee?.appraisals ?? [];

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={
                    <RMSAvatar
                        type={"appraisee"}
                        badge={uuid ? "" : "warning"}
                    />
                }
                title={
                    <Typography component="h2" className="card-header-title">
                        {appraisee?.name ?? "Appraisee"}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {appraisee?.jobRole ?? "Job role not specified"}
                    </Typography>
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        {uuid && (
                            <Button
                                variant="contained"
                                color="neutral"
                                disableElevation={true}
                                aria-label="Appraisee details"
                                component={Link}
                                to={`/rms/appraisees/${uuid}`}
                                endIcon={<KeyboardArrowRightOutlinedIcon />}
                            >
                                <Typography
                                    variant={"span"}
                                    sx={{ color: "rgba(0,0,0,0.7)" }}
                                >
                                    View
                                </Typography>
                            </Button>
                        )}
                    </Stack>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <AppraisalTable
                        model="review"
                        items={appraisals}
                        appraisee={{ uuid: uuid }}
                        isAppraiser={true}
                    />
                </Box>
            </CardContent>
        </Card>
    );
}

export default AppraiseeCard;
